import { gql } from '@apollo/client';

export const upsertAvailabilityPeriodMutation = gql`
  mutation upsertAvailabilityPeriod($input: [UpsertAvailabilityPeriodInput]!) {
    upsertAvailabilityPeriod(input: $input) {
      id
    }
  }
`;
export const deleteAvailabilityPeriodMutation = gql`
  mutation deleteAvailabilityPeriod($input: DeleteAvailabilityPeriodInput!) {
    deleteAvailabilityPeriod(input: $input) {
      success
    }
  }
`;

export const deleteBulkAvailabilityPeriodMutation = gql`
  mutation deleteAvailabilityPeriodFranchise($input: DeleteAvailabilityPeriodFranchiseInput!) {
    deleteAvailabilityPeriodFranchise(input: $input) {
      success
    }
  }
`;